import { Injectable } from '@angular/core';
import { Parse, Stringify } from '../functions/copy.function';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private prefix = 'cat_';
  constructor() {}

  getFromStorage(key: string): any | undefined {
    const localVariable = localStorage.getItem(`${this.prefix}${key}`);
    if (localVariable) {
      return Parse(localVariable);
    }
    return undefined;
  }

  setInStorage(key: string, data: any): void {
    localStorage.setItem(this.prefix + '' + key, Stringify(data));
  }

  removeFromStorage(key: string): void {
    localStorage.removeItem(this.prefix + '' + key);
  }

  clearStorage(): void {
    localStorage.clear();
  }

  isLoggedIn(): boolean {
    return !!this.getFromStorage('token');
  }
}
